module.exports = __webpack_public_path__ + "img/ic-support-purple.c77dc259.svg";